var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({domProps:{"innerHTML":_vm._s(_vm.svg)}},'div',attrs,false),on))]}}])},[_c('span',[_vm._v(" Este Lead cuenta con broker externo. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }